import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAgGridApi } from "tap/components/AGGrid/hooks.js";
import { usePMXPricesAndDatesGridUtils } from "./utils/gridUtils";
import { usePMXPricesAndDatesData } from "../../hooks/usePMXPricesAndDatesData";
import { normalizeSpringDataPage } from "tap/utils/pagination.js";
import DataGrid from "@dtci/spellbook/DataGrid";
import styles from "../../../../components/AGGrid/details-table.module.scss";

/**
 * PMX Prices and Dates Grid - Displays PMX pricing data in a read-only grid.
 */
export const PMXPricesAndDatesGrid = () => {
  const agGridApi = useAgGridApi();
  const { pricesAndDates, refreshPMXPricesAndDates } = useSelector(
    (s) => s.pmxPricesAndDates,
  );
  const {
    fetchPMXPricesAndDates,
    updatePMXPricesAndDates,
    pmxPricesAndDatesRange,
    filterForm,
    itemsPerPage,
  } = usePMXPricesAndDatesData();

  const { columns } = usePMXPricesAndDatesGridUtils({ columnHandlers: [] });

  const refreshList = async () => {
    const data = await fetchPMXPricesAndDates(
      pmxPricesAndDatesRange,
      filterForm,
    );
    if (data) {
      const meta = normalizeSpringDataPage(data, itemsPerPage);
      updatePMXPricesAndDates({
        pricesAndDates: data?.content,
        totalPages: meta?.totalPages ?? data?.totalPages,
        totalItems: meta?.totalElements ?? data?.totalElements,
        currentPage: meta?.currentPage ?? data?.pageable?.pageNumber ?? 0,
      });
    }
  };

  useEffect(() => {
    if (refreshPMXPricesAndDates) {
      refreshList();
      updatePMXPricesAndDates({ refreshPMXPricesAndDates: false });
    }
  }, [refreshPMXPricesAndDates]);

  return (
    <DataGrid
      className={styles.dataGrid}
      autoSizing
      agGrid={{
        ref: agGridApi.AgGridApiRef,
        rowData: pricesAndDates ?? [],
        suppressColumnStateReset: true,
        headerHeight: 45,
        defaultColDef: {
          wrapText: true,
          autoHeight: true,
          resizable: true,
          suppressHeaderMenuButton: true,
          cellStyle: {
            paddingTop: "10px",
            paddingBottom: "10px",
            wordBreak: "break-word",
          },
        },
      }}
      bordered="none"
      columnDefs={columns}
      sortable={false}
      striped
      noResultsMessage={"No PMX Prices and Dates Found"}
    />
  );
};
